import React, { useState } from 'react';
import CycleRenewalBanner from '../components/banners/CycleRenewalBanner';

export default function TestCycleRenewal() {
  const [showBanner, setShowBanner] = useState(true);

  // Mock renewal info based on your actual cycle
  const mockRenewalInfo = {
    newStart: '2029-01-01',
    newEnd: '2032-12-31',
    renewalDate: '2029-01-01'
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="space-y-6">
        <h1 className="text-2xl font-bold text-gray-900">
          Cycle Renewal Banner Test
        </h1>
        
        <p className="text-gray-600">
          This is how the banner will look when your certification cycle automatically renews.
        </p>

        {showBanner && (
          <CycleRenewalBanner 
            renewalInfo={mockRenewalInfo} 
            onDismiss={() => setShowBanner(false)} 
          />
        )}

        {!showBanner && (
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
            <p className="text-gray-600">Banner dismissed!</p>
            <button
              onClick={() => setShowBanner(true)}
              className="mt-2 text-sm text-primary hover:text-primary-dark underline"
            >
              Show banner again
            </button>
          </div>
        )}

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <h2 className="font-semibold text-blue-900 mb-2">Test Scenario:</h2>
          <ul className="text-sm text-blue-800 space-y-1">
            <li>• Old Cycle: 7/1/2025 - 12/31/2028</li>
            <li>• New Cycle: 1/1/2029 - 12/31/2032</li>
            <li>• Renewal Date: 1/1/2029</li>
            <li>• Certifying Body: RID (4-year cycle)</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
